import React from 'react';

interface ErrorProps {
    message: string;
}

export default function Error({ message }: ErrorProps) {
    return (
        <div className="bg-red-50 border border-red-200 text-red-800 p-4 rounded-lg m-6">
            {message}
        </div>
    );
}
